import React from 'react';
import styles from './FeedHeader.module.scss';

const FeedHeader: React.FC = () => {
  return null;
};

export default FeedHeader; 